<template>
  <div v-if="showComponent" class="card card-material card-type" :class="{ 'card-type': filters.length <= 10, 'card-side': filters.length > 10 }">
    <div class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div @click="openFilter()" class="card-title card-material-title" :class="{ 'clear-select': filterThird }">
        {{ filterTitle }}
        <div v-if="filterThird" class="badge badge-selected float-right">{{ selectedName }}</div>
        <font-awesome-icon v-if="showFilter && filterThird" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter">
        <div v-if="filters.length <= 10" class="select-core row">
          <div v-for="filter in filters" v-bind:key="filter" v-on:click.stop.prevent="select(filter)" class="card card-select card-body col-md-6 m-md-1" :class="{ 'selected': filter === filterThird }">
            <div class="card-core">
              {{ filter || 'Geen' }}
            </div>
          </div>
        </div>

        <div v-else class="select-type">
          <div class="form-group">
            <v-select placeholder="Zoek op code of omschrijving" v-model="filterThirdValue" v-on:click.stop.prevent="click()" :filter-by="filterProducts" :options="filters" :clearable="false" ref="dropdown">
              <template slot="option" slot-scope="option">
                <span class="side-select-label">{{ option.label }}</span>
                {{ option.description }}
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_MATERIAL_FILTER_THIRD, SET_MATERIAL_THICKNESS, SET_MATERIAL_PRODUCT } from '../../../store/types'

  export default {
    data() {
      return {
        showFilter: false,
        filterProducts: (option, label, search) => {
          let keyword = search.toLowerCase()
          return option.toLowerCase().indexOf(keyword) > -1 || option.toLowerCase().indexOf(keyword) > -1
        }
      }
    },
    computed: {
      filterThirdValue: {
        get() {
          return !this.$store.getters.filterThird ? false : this.$store.getters.filterThird
        },
        set(value) {
          this.select(value)
        }
      },
      filters() {
        if (this.$store.getters.filterSecond) {
          let filterDeliveryProgram = this.$store.getters.filterDeliveryProgram
          let filterFirst = this.$store.getters.filterFirst
          let filterSecond = this.$store.getters.filterSecond

          let products = this.products.filter((product) => (product.deliveryprogram === filterDeliveryProgram && product.filter_1 === filterFirst && product.filter_2 === filterSecond))

          // Only get third filters
          let filters = products.map(product => product.filter_3)
          // Sort by thickness
          filters = [...new Set(filters.sort((a, b) => a - b))]

          // If only 1 option is left, just pre-select the item, and move on
          if (filters.length === 1) {
            if (filters[0] === '') {
              this.select('geen')
            } else {
              this.select(filters[0])
            }
          }

          return filters
        }

        return []
      },
      products() {
        return this.$store.getters.products
      },
      filterSecond() {
        return this.$store.getters.filterSecond
      },
      filterThird() {
        return this.$store.getters.filterThird
      },
      isActive() {
        return this.showFilter || (!this.filterThird && !this.$store.getters.materialThickness)
      },
      filterTitle() {
        return this.$store.getters.filterFirst.indexOf('HPL') !== -1 ? 'Kernmateriaal' : 'Materiaal'
      },
      selectedName() {
        if (this.filterThird) {
          return this.filterThird
        }

        return ''
      },
      showComponent() {
        return this.filterSecond && this.filters.length > 0 && this.filters[0] !== '' && this.filters[0] !== 'Meubelpanelen'
      }
    },
    methods: {
      select(select) {
        if (select !== this.filterThird && this.filterThird !== 'geen') {
          // Reset the other material filters
          this.$store.dispatch(SET_MATERIAL_THICKNESS, null)
          this.$store.dispatch(SET_MATERIAL_PRODUCT, null)

          this.$store.dispatch(SET_MATERIAL_FILTER_THIRD, select || 'geen')
        }
        this.showFilter = false
      },
      openFilter() {
        if (this.filterThird && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.filterThird) {
          this.showFilter = false
        }
      }
    },
    updated() {
      this.showFilter = (this.$store.getters.loadingMaterial) ? false : (!this.filterThirdValue) ? true : this.showFilter
    },
    created() {
      this.showFilter = !this.filterThirdValue
    }
  }
</script>

<style lang="scss" scoped>
</style>
